const veins_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },

   {
      "question":"Does ##name## have Varicose Veins?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "VARICOSE VEINS AND/OR POST- PHLEBITIC SYNDROME",
         number: "3A"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_2[0].RadioButtonList[0]",
      "ref":1,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },   
   {
      "question":"Indicate extremity for Varicose Veins",
      "sub":"Please, Indicate sides",
      "type":"radio",
      "show": false,
      "refId":1,
      "section": {
         page: "2",
         title: "VARICOSE VEINS AND/OR POST- PHLEBITIC SYNDROME",
         number: "3A"
      },
      "questions":[
         {
            "label":"Upper extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[3]",
                  "sub":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[3]",
                  "sub":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[3]",
                  "sub":""
               }
            ],
            "answer":"Both"
         },
         {
            "label":"Lower extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[1]",
                  "sub":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[1]",
                  "sub":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[1]",
                  "sub":""
               }
            ],
            "answer":"Both"
         }
      ]
   },


   {
      "question":"Does ##name## have Post-Phlebitic syndrome of any Etiology?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "VARICOSE VEINS AND/OR POST- PHLEBITIC SYNDROME",
         number: "3B"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_2[0].RadioButtonList[1]",
      "ref":1,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Indicate extremity for Varicose Veins",
      "sub":"Please, Indicate sides",
      "type":"radio",
      "show": false,
      "refId":1,
      "section": {
         page: "2",
         title: "VARICOSE VEINS AND/OR POST- PHLEBITIC SYNDROME",
         number: "3B"
      },
      "questions":[
         {
            "label":"Upper extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[5]",
                  "sub":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[5]",
                  "sub":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[5]",
                  "sub":""
               }
            ],
            "answer":"Both"
         },
         {
            "label":"Lower extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[4]",
                  "sub":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[4]",
                  "sub":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[4]",
                  "sub":""
               }
            ],
            "answer":"Both"
         }
      ]
   },
   


   {
      "question":"Check all Symptoms that apply and indicate extremity affected?",
      "sub":"Please, Indicate sides of each extremity",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "2",
         title: "VARICOSE VEINS AND/OR POST- PHLEBITIC SYNDROME",
         number: "3C"
      },
      "questions":[
         {
            "main":"Asymptomatic palpable varicose veins",
            "dbqName":"F[0].Page_2[0].B1[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].#area[0].Right6[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].#area[0].Left6[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].#area[0].Both6[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].#area[1].Right6[6]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].#area[1].Left6[6]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].#area[1].Both6[6]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Asymptomatic visible varicose veins",
            "dbqName":"F[0].Page_2[0].B2[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right7[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left7[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both7[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[7]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[7]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[7]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Aching in leg after prolonged standing",
            "dbqName":"F[0].Page_2[0].B3[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right8[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left8[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both8[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Lower Extremity",
         },
         {
            "main":"Fatigue in leg after prolonged standing",
            "dbqName":"F[0].Page_2[0].B1[1]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[2]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[2]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[2]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Lower Extremity"
         },
         {
            "main":"Aching in leg after prolonged walking",
            "dbqName":"F[0].Page_2[0].B2[1]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right7[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left7[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both7[1]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Lower Extremity",
         },
         {
            "main":"Fatigue in leg after prolonged walking",
            "dbqName":"F[0].Page_2[0].B3[1]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right8[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left8[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both8[1]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Lower Extremity",
         },
         {
            "main":"Symptoms relieved by elevation of extremity",
            "dbqName":"F[0].Page_2[0].B4[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right9[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left9[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both9[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[8]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[8]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[8]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Symptoms relieved by compression hosiery",
            "dbqName":"F[0].Page_2[0].B5[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right10[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left10[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both10[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[9]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[9]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[9]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Constant pain at rest",
            "dbqName":"F[0].Page_2[0].C9[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right19[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left19[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both19[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[10]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[10]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[10]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },                     
      ],
      "answer":""
   },
   
   {
      "question":"Check all findings and/or signs that apply and indicate extremity affected?",
      "sub":"Please, Indicate sides of each extremity",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "2",
         title: "VARICOSE VEINS AND/OR POST- PHLEBITIC SYNDROME",
         number: "3D"
      },
      "questions":[
         {
            "main":"Beginning stasis pigmentation",
            "dbqName":"F[0].Page_2[0].C1[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right11[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left11[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both11[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[11]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[11]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[11]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Persistent stasis pigmentation",
            "dbqName":"F[0].Page_2[0].C3[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right13[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left13[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both13[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[12]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[12]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[12]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Beginning eczema",
            "dbqName":"F[0].Page_2[0].C2[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right12[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left12[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both12[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[13]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[13]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[13]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Persistent edema",
            "dbqName":"F[0].Page_2[0].C1[1]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right11[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left11[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both11[1]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[14]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[14]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[14]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Intermittent edema of extremity",
            "dbqName":"F[0].Page_2[0].C4[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right14[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left14[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both14[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[15]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[15]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[15]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Persistent edema that is incompletely relieved by elevation of extremity",
            "dbqName":"F[0].Page_2[0].C5[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right15[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left15[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both15[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[16]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[16]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[16]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Massive board-like edema",
            "dbqName":"F[0].Page_2[0].C8[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right18[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left18[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both18[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[17]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[17]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[17]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Intermittent ulceration",
            "dbqName":"F[0].Page_2[0].C3[1]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right13[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left13[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both13[1]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[18]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[18]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[18]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Persistent ulceration",
            "dbqName":"F[0].Page_2[0].C4[2]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right14[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left14[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both14[1]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[19]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[19]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[19]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },
         {
            "main":"Persistent subcutaneous induration",
            "dbqName":"F[0].Page_2[0].C7[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right17[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left17[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both17[0]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Upper Extremity",
            "subItems2": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_2[0].Right6[20]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_2[0].Left6[20]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_2[0].Both6[20]",
                  "colWidth": 4,
                  "answer":""
               }
            ],
            "subAnswer2":"",
            "subItems2Label" :"Lower Extremity",
         },                     
      ],
      "answer":""
   },


   {
      "question":"Additional Comments",
      "sub":"",
      "type":"textarea",
      "optional": true,
      "show": true,
      "section": {
         page: "7",
         title: "REMARKS",
         number: "15A"
      },
      "dbqName":"F[0].Page_7[0].Comments16[0]",
      "answer":""
   }
 ]

 export default veins_questions ;
